import React, { useState, useEffect } from "react";
import { ListGroup, ListGroupItem, Row, Button } from "reactstrap";
import PropTypes from "prop-types";

import { getAccountType } from "../types";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalPersonalReference from "../../Modal/ModalPersonalReference";
import { CircularProgress } from "../../../..";
import { AccountMode } from "../../../../utils/Helper";

const PersonalReferencesTab = ({
  accountId,
  references,
  isReadOnly,
  setAccountData,
  services,
  mode,
  groups,
  bankAccounts,
  signatureSets,
}) => {
  const [fetching, setFetching] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    referenceId: undefined,
    saving: false,
  });
  const [modalPersonalReference, setModalPersonalReference] = useState({
    open: false,
    saving: false,
  });

  const toggleModalConfirm = () => {
    setModalConfirm({
      open: false,
      title: "",
      referenceId: undefined,
      saving: false,
    });
  };

  const toggleModalReference = () => {
    setModalPersonalReference({
      ...modalPersonalReference,
      open: !modalPersonalReference.open,
    });
  };

  const handleDeleteReference = (id) => {
    setModalConfirm({
      open: true,
      title: "Are you sure you want to delete the selected Personal Reference?",
      referenceId: id,
      saving: false,
    });
  };

  const handleAddReference = (reference) => {
    const newReference = reference;
    const account = {
      AccountId: accountId,
      AccountOnboardingId: accountId,
      PersonalReferences: [newReference],
    };
    const body = {
      account,
      accountChangeType: getAccountType.References,
    };
    setModalPersonalReference({ ...modalPersonalReference, saving: true });
    if (mode === AccountMode.New) {
      services.fetchNewAccount(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newReferences = references;
          newReference.AccountPersonalReferenceId = response.Id;
          newReferences.push(newReference);
          account.PersonalReferences = newReferences;
          setAccountData(account, true);
          setModalPersonalReference({
            saving: false,
            open: false,
          });
        } else {
          setModalPersonalReference({
            ...modalPersonalReference,
            saving: false,
          });
        }
      });
    } else {
      services.fetchAccountUpdate(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newReferences = references;
          newReference.AccountPersonalReferenceId = response.Id;
          newReferences.push(newReference);
          account.PersonalReferences = newReferences;
          setAccountData(account, true);
          setModalPersonalReference({
            saving: false,
            open: false,
          });
        } else {
          setModalPersonalReference({
            ...modalPersonalReference,
            saving: false,
          });
        }
      });
    }
  };

  const deletePersonalReference = () => {
    const deleteReferenceId = modalConfirm.referenceId;
    const account = {
      AccountId: accountId,
      AccountOnboardingId: accountId,
      PersonalReferences: [
        {
          AccountPersonalReferenceId: deleteReferenceId,
        },
      ],
    };
    const body = {
      account,
      accountChangeType: getAccountType.References,
    };
    setModalConfirm({ ...modalConfirm, open: true, saving: true });
    if (mode === AccountMode.New) {
      services.fetchNewAccount(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newReferences = references;
          let index = -1;
          newReferences.map((ref, i) => {
            if (deleteReferenceId === ref.AccountPersonalReferenceId) {
              index = i;
            }
            return {};
          });
          if (index > -1) {
            newReferences.splice(index, 1);
          }
          account.PersonalReferences = newReferences;
          setAccountData(account, true);
          toggleModalConfirm();
        } else {
          setModalConfirm({
            ...modalConfirm,
            saving: false,
          });
        }
      });
    } else {
      services.fetchAccountUpdate(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newReferences = references;
          let index = -1;
          newReferences.map((ref, i) => {
            if (deleteReferenceId === ref.AccountPersonalReferenceId) {
              index = i;
            }
            return {};
          });
          if (index > -1) {
            newReferences.splice(index, 1);
          }
          account.PersonalReferences = newReferences;
          setAccountData(account, true);
          toggleModalConfirm();
        } else {
          setModalConfirm({
            ...modalConfirm,
            saving: false,
          });
        }
      });
    }
  };

  useEffect(() => {
    const body = {
      AccountGetInfo: {
        GetAccountDataId: accountId,
        GetAccountDataOnboardingId: accountId,
        GetAccountDataType: getAccountType.References,
      },
    };
    if (mode !== AccountMode.New) {
      if (!references && !fetching) {
        services.fetchAccountSectorInfo(body, (response) => {
          if (response && response.SDTAccount) {
            setAccountData(
              {
                BankAccounts: bankAccounts,
                SignatureSets: signatureSets,
                AccountId: accountId,
                PersonalReferences: response.SDTAccount.PersonalReferences,
              },
              false
            );
          }
          setFetching(false);
        });
        setFetching(true);
      }
    }
  }, [references, fetching, accountId, setAccountData, services]);

  useEffect(() => {
    const body = {
      AccountGetInfo: {
        GetAccountDataId: accountId,
        GetAccountDataOnboardingId: accountId,
        GetAccountDataType: getAccountType.References,
      },
    };
    if (mode === AccountMode.New && !fetching) {
      services.fetchNewAccountInfo(body, (data) => {
        if (data && data.SDTAccount) {
          setAccountData(
            {
              AccountId: accountId,
              PersonalReferences: data.SDTAccount.PersonalReferences,
              Groups: groups,
              BankAccounts: bankAccounts,
              SignatureSets: signatureSets,
            },
            false
          );
          setFetching(false);
        }
      });
      setFetching(true);
    }
  }, []);

  return (
    <div>
      {!fetching ? (
        <React.Fragment>
          {references &&
            references.map((personalReference) => (
              <ListGroup key={personalReference.AccountPersonalReferenceId} style={{ marginBottom: 10 }}>
                <ListGroupItem>
                  <Row>
                    {"Name: "}
                    {personalReference.AccountPersonalReferenceName}
                    <div
                      style={{ cursor: "pointer", float: "right", marginLeft: 20 }}
                      onClick={() => handleDeleteReference(personalReference.AccountPersonalReferenceId)}
                    >
                      <i className="fa fa-trash" />
                    </div>
                  </Row>
                  <Row>
                    {"Phone: "}
                    {personalReference.AccountPersonalReferencePhone}
                  </Row>
                </ListGroupItem>
              </ListGroup>
            ))}
          {!isReadOnly && (
            <Button color="primary" onClick={toggleModalReference}>
              Add new Personal Reference
            </Button>
          )}
        </React.Fragment>
      ) : (
        <CircularProgress sm />
      )}
      <ModalConfirm {...modalConfirm} callback={deletePersonalReference} toggle={toggleModalConfirm} />
      <ModalPersonalReference
        {...modalPersonalReference}
        toggle={toggleModalReference}
        onSave={handleAddReference}
      />
    </div>
  );
};

PersonalReferencesTab.propTypes = {
  accountId: PropTypes.any.isRequired,
  references: PropTypes.array.isRequired,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
};

export default PersonalReferencesTab;
